import { Type } from 'class-transformer/decorators';
import { ArrayNotEmpty, IsArray, ValidateNested } from 'class-validator';
import { StaffInvitationResolveActions } from './staff-invitation-resolve.types';

export class StaffInvitationResolveBatchRequestDto {
  @IsArray()
  @ArrayNotEmpty()
  @ValidateNested({ each: true })
  @Type(() => StaffInvitationResolveActions)
  actions: StaffInvitationResolveActions[];
}
